var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 1C6 0.447715 5.55228 2.41411e-08 5 0C4.44772 -2.41411e-08 4 0.447715 4 1L6 1ZM4 9C4 9.55229 4.44771 10 5 10C5.55228 10 6 9.55229 6 9L4 9ZM4 1L4 9L6 9L6 1L4 1Z",
    fill: "#0B907B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 4C0.447715 4 0 4.44772 0 5C0 5.55228 0.447715 6 1 6V4ZM9 6C9.55229 6 10 5.55228 10 5C10 4.44772 9.55229 4 9 4V6ZM1 6H9V4H1V6Z",
    fill: "#0B907B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusGreen);
export default __webpack_public_path__ + "static/media/plus-green.93a302dc51c319ccdc50cc227c1595a9.svg";
export { ForwardRef as ReactComponent };